interface LoadingSpinnerProps {
  className?: string
}

export default function LoadingSpinner({ className = 'border-cyan-400' }: LoadingSpinnerProps) {
  return (
    <div className="flex items-center justify-center py-12">
      <div className={`h-6 w-6 rounded-full border-2 border-t-transparent animate-spin ${className}`} />
    </div>
  )
}
